'use client';

import { useEffect } from 'react';
import { isOtPerfEnabled, OT_CONSENT_COOKIE_NAME } from '@ab-inbev-eu/utils/onetrust';

import { useApplicationStore } from '../../stores/application.store';
import { getCookie } from '../../utils/functions.client';
import { publicConfig } from '../../utils/config';

export default function Braze() {
  const {
    BRAZE: { API_KEY, SDK_ENDPOINT },
  } = publicConfig();
  useEffect(() => {
    void (async () => {
      const braze = await import('@braze/web-sdk');
      function initBraze() {
        if (API_KEY && SDK_ENDPOINT) {
          braze.initialize(API_KEY, {
            baseUrl: SDK_ENDPOINT,
            noCookies: !isOtPerfEnabled(decodeURIComponent(getCookie(OT_CONSENT_COOKIE_NAME) ?? '')),
            allowUserSuppliedJavascript: true,
          });

          // optionally show all in-app messages without custom handling
          braze.automaticallyShowInAppMessages();
          useApplicationStore.setState({ isBrazeInitialized: true });
        }
      }
      initBraze();
      window.addEventListener('consent.onetrust', initBraze);
      return () => {
        window.removeEventListener('consent.onetrust', initBraze);
      };
    })();
  }, []);

  return null;
}
